import { render, staticRenderFns } from "./companyInvitation.vue?vue&type=template&id=d0049936&"
import script from "./companyInvitation.vue?vue&type=script&lang=js&"
export * from "./companyInvitation.vue?vue&type=script&lang=js&"
import style0 from "./companyInvitation.vue?vue&type=style&index=0&id=d0049936&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports